export default "__VITE_ASSET__CO86fiLQ__"